<template>
<div>
    <div v-if="field.extra.attributes.includes('vue_form_value')"/>
    <v-text-field
            v-else-if="!field.extra.is_autocomplete"
            :label="label"
            outlined
            v-model="formValues[field.nombre]"
            :placeholder="field.ayuda"
            :class="field.extra.attributes"
            :readonly="readonly"
            :rules="rules"
            :aria-required="true"
            :error="field.extra.attributes.includes('error_field')"
            :error-messages="errorMessage"
            @input="v => {toUppercase(v)}"
            @blur="tryExecuteApiAjaxEvent('blur')"
            :name="`process[${field.nombre}]`"
    >
        <template v-slot:append-outer class="mt-0" v-if="apiAjax && formValues[field.nombre]">
            <v-btn color="primary" @click="tryExecuteApiAjaxEvent('blur')"><v-icon>fas fa-search</v-icon></v-btn>
        </template>
    </v-text-field>

     <v-autocomplete
        v-else
        v-model="modelValue"
        :items="items"
        :loading="isLoading"
        :rules="rules"
        :search-input.sync="search"
        :placeholder="field.ayuda"
        :class="field.extra.attributes"
        :readonly="isReadonly"
        :aria-required="true"
        :error="field.extra.attributes.includes('error_field')"
        :error-messages="errorMessage"
        @change="setNewDynamicFormValue($event)"
        :no-data-text="noData"
        outlined
        dense
        auto-select-first
        return-object
        eager
    ></v-autocomplete>
    </div>
</template>

<script>
    import procedureFormValidator from "bestgob-core/form/procedure.form.validator";
    import {mapActions, mapState} from "vuex";
    import {procedureAutocompleteRequest} from "bestgob-core/api/models";


    export default {
        name: "TextField",
        props: ['field', 'readonly', 'label', 'formValues', 'apiAjax', 'stageId'],

        data() {
            return {
                rules: [],
                apiAjaxExecuted: false,
                errorMessage: '',
                aux: '',
                items: [],
                auxSearch: null,
                modelValue: null,
                isLoading: false,
                search: null,
                isReadonly: this.readonly,
                noData: 'Buscando..'
               
            }
        },

        watch:{
            '$store.state.procedures.apiAjaxContent'(){
                if (this.apiAjaxExecuted){
                    if (this.proceduresStore.apiAjaxContent !== null && this.proceduresStore.apiAjaxContent.error){
                        this.errorMessage = this.proceduresStore.apiAjaxContent.error
                        this.apiAjaxExecuted = false
                    }else if (Array.isArray(this.proceduresStore.apiAjaxContent) && this.proceduresStore.apiAjaxContent.length === 0){
                        this.errorMessage = 'No se econtraron resultados'
                    }else {
                        this.errorMessage = ''
                    }
                }
            },
            '$store.state.procedures.autoComplete'(){
                
                if(this.$store.state.procedures.autoComplete && this.field.extra.is_autocomplete){
                    const getProp = prop => items => items[prop];
                    const getFoo = getProp('label');
                    // console.log(this.items.map(getFoo));
                    // console.log(this.$store.state.procedures.autoComplete);
                    // console.log( typeof( this.$store.state.procedures.autoComplete ) );

                    try {
                        this.items = this.$store.state.procedures.autoComplete.map(getFoo)
                        this.isLoading = false
                    }catch(e){
                        console.log('valores por default no validos')
                    }
                }

            },
            async search(val){
                this.isLoading = true
                this.isReadonly = true
                let request = procedureAutocompleteRequest()
                request.field_id = this.field.id
                request.stage_id = this.stageId
                request.query = val
                // eslint-disable-next-line no-unused-vars
                await this.getAutoComplete(request).then(data =>{
                    this.isReadonly = false
                   try{
                       var searchInItems = this.items.map(item => item.label.indexOf(val) > -1)
                        if(searchInItems.find(item => item == false)){
                            this.noData = 'No se encontraron coincidencias'
                        }

                   }catch(e){
                        this.noData = 'No se encontraron coincidencias'
                   }
                }
                ).catch(
                    this.isReadonly = false

                );
               

            }   
        },

        computed: {
            ...mapState({proceduresStore: state => state.procedures}),
        },

        async mounted() {
            // this.field.value = this.formValues[this.field.nombre];
            if(!this.formValues[this.field.nombre]  && this.field.extra.is_autocomplete ){
                let request = procedureAutocompleteRequest()
                request.field_id = this.field.id //id campo 
                request.stage_id = this.stageId //id de la etapa
                request.query = this.formValues[this.field.nombre]
                await this.getAutoComplete(request);
                !this.proceduresStore.autoComplete  ? this.formValues[this.field.nombre] = null : ''
                
            }

            if(this.field.extra.is_autocomplete && this.$store.state.procedures.autoComplete){
                const getProp = prop => items => items[prop];
                const getFoo = getProp('label');
                // console.log(this.items.map(getFoo));
                this.items = this.$store.state.procedures.autoComplete.map(getFoo)
                this.$forceUpdate();

            }


            
            this.addAllValidations()
            if (this.field.extra.attributes.includes('vue_form_value')){
                this.$root.$on(`form_value_${this.field.nombre}`, this.setNewDynamicFormValue)
            }

        },

        methods: {
            ...mapActions('procedures', ['getAutoComplete']),


            getLabel(){
                if (this.field.validacion.required){
                    return '* ' + this.field.etiqueta
                }

                return this.field.etiqueta
            },

            addAllValidations(){
                let rules = []

                rules.push(procedureFormValidator.input.required(this.field.validacion.required, this.readonly))

                if (this.field.validacion.curp || this.field.nombre == 'curp'){
                    rules.push(procedureFormValidator.input.curp)
                }else if (this.field.validacion.rfc || this.field.nombre == 'rfc'){
                    rules.push(procedureFormValidator.input.rfc)
                }
                if (this.field.validacion.min_length || this.field.validacion.max_length){
                    rules.push(procedureFormValidator.input.min_max_length(this.field.validacion.min_length, this.field.validacion.max_length))
                }
                if (this.field.validacion.exact_length){
                    rules.push(procedureFormValidator.input.exact_length(this.field.validacion.exact_length))
                }
                if (this.field.validacion.numeric){
                    rules.push(procedureFormValidator.input.numeric)
                }

                this.rules = rules
            },

            toUppercase(value){
                if (this.field.extra.attributes && this.field.extra.attributes.includes('uppercase')){
                    this.formValues[this.field.nombre] = value.toUpperCase()
                }
            },

            tryExecuteApiAjaxEvent(eventType){
                if (this.apiAjax != null && this.formValues[this.field.nombre]){
                    if (eventType === this.apiAjax['event']){
                        this.apiAjaxExecuted = true
                        this.$root.$emit(`fire_${this.apiAjax.originFieldId}`)
                    }
                }
            },

            /**
             * Set form value dynamically, from javascript calls and autocompletado supprt
             */
            setNewDynamicFormValue(newValue){
                this.field.extra.is_autocomplete ? 
                (this.formValues[this.field.nombre] = JSON.stringify({  text: newValue, value : newValue }) ,
                this.field.value = JSON.stringify({  text: newValue, value : newValue })   , console.log('aqui') ) :
                    this.formValues[this.field.nombre] = newValue
                
                
                this.isLoading = false
            }
        }
    }
</script>

<style>
    .uppercase input{text-transform: uppercase}
    .v-text-field * .v-input__slot{
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
        
    }
</style>